module.exports = __webpack_public_path__ + "static/img/13.01f3687.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/6/eng/13.png
// module id = XtbH
// module chunks = 0